import { trackAbTastyEvent } from "~/lib/track-abtasty-event.client";

import { pushEvent } from "./gtm-sink";

/**
 * Multi-sink event layer — non-ecommerce PLP filter / sort events.
 *
 * `filterSort` mirrors the production GTM container's own sort listener (a custom
 * HTML tag bound to `select#sort-order-select`) which pushes
 * `{ event: 'filterSort', selectedElement: <sort option text> }`, consumed by an
 * existing `filterSort` trigger. The Workers PLP sort UI is a different DOM
 * (`sort-popover`), so that container script never fires here — the app pushes
 * the same event the trigger already listens for.
 *
 * Non-ecommerce, so it uses `pushEvent` (no `{ecommerce:null}` flush) and carries
 * no `ecommerce` block.
 *
 * Design: docs/analytics-segment-first-event-layer.md
 */
export type FilterSortEvent = {
  event: "filterSort";
  /** The selected sort option's display label (SFRA `selectedOption.text`). */
  selectedElement: string;
};

export const buildFilterSortEvent = (
  selectedElement: string,
): FilterSortEvent => ({
  event: "filterSort",
  selectedElement,
});

/** Emit the `filterSort` event when the shopper picks a sort option. */
export const emitFilterSort = (selectedElement: string): void => {
  pushEvent(buildFilterSortEvent(selectedElement));
  // AB Tasty Universal Collect EVENT hit (SFCC-12079).
  trackAbTastyEvent({ ec: "User Engagement", ea: "filter_sort" });
};
